import { render, staticRenderFns } from "./PZPopup.vue?vue&type=template&id=752e63e0&scoped=true"
import script from "./PZPopup.vue?vue&type=script&lang=js"
export * from "./PZPopup.vue?vue&type=script&lang=js"
import style0 from "./PZPopup.vue?vue&type=style&index=0&id=752e63e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "752e63e0",
  null
  
)

export default component.exports